import * as React from 'react'
import './Card.css'

const Card = ({ img, name, description, url_preview, url_github, cardWidth, minHeight, animation, noAnimation }) => {
  const animations = noAnimation ? {} : { 'data-sal': animation, 'data-sal-delay': '100', 'data-sal-easing': 'ease-in-out' }

  return (
    <div className='card col-block service-item add-top' style={{ width: cardWidth, minHeight }} {...animations}>
      <img className='card-img' src={img} alt={name} />
      <div className='card-overlay'></div>

      <div className='card-content'>
        <div className='front-card'>
          <h2 className='card-name'>{name}</h2>
        </div>
        <div className='back-card'>
          <h3 className='card-description'> {description} </h3>
          <a href={url_preview} rel='noreferrer' target='_blank' className='btn btn--stroke card-alt-btn add-top add-bottom'>
            Live Preview
          </a>
          <a href={url_github} rel='noreferrer' target='_blank' className='btn btn--stroke card-alt-btn add-top add-bottom'>
            See on Github
          </a>
        </div>
      </div>
    </div>
  )
}

export default Card
